import { useEffect, useRef, useState } from "react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface DescriptionProps {
  description: string;
}

export default function Description({ description }: DescriptionProps) {
  const txtRef = useRef<HTMLParagraphElement>(null);
  const [expanded, setExpanded] = useState(false);
  const [expandable, setExpandable] = useState(false);

  const handleToggleExpanded = () => setExpanded((prevState) => !prevState);

  useEffect(() => {
    if (!txtRef.current) {
      return;
    }

    const resizeObserver = new ResizeObserver((entries) => {
      const { clientHeight, scrollHeight } = entries[0].target;

      resizeObserver.disconnect();
      setExpandable(scrollHeight > clientHeight);
    });

    resizeObserver.observe(txtRef.current);

    return () => resizeObserver.disconnect();
  }, []);

  return (
    <div>
      <p
        className={cn(
          "whitespace-pre-line text-14/[1.71em] text-fog md:pt-[31px] md:text-white/80",
          !expanded && "line-clamp-3 md:line-clamp-6"
        )}
        ref={txtRef}
      >
        {description}
      </p>
      {expandable && (
        <Button
          className="h-6 font-semibold text-14 text-white"
          onClick={handleToggleExpanded}
        >
          See {expanded ? "less" : "more"}
        </Button>
      )}
    </div>
  );
}
